import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PersonalCare from "../pages/services/personal-care/page";
import CompanionCare from "../pages/services/companion-care/page";
import AlzheimersDementiaCare from "../pages/services/alzheimers-dementia-care/page";
import RespiteCare from "../pages/services/respite-care/page";
import PostHospitalRecovery from "../pages/services/post-hospital-recovery/page";
import About from "../pages/about/page";
import OaklandIL from "../pages/locations/oakland-il/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services/personal-care", element: <PersonalCare /> },
  { path: "/services/companion-care", element: <CompanionCare /> },
  { path: "/services/alzheimers-dementia-care", element: <AlzheimersDementiaCare /> },
  { path: "/services/respite-care", element: <RespiteCare /> },
  { path: "/services/post-hospital-recovery", element: <PostHospitalRecovery /> },
  { path: "/about", element: <About /> },
  { path: "/locations/oakland-il", element: <OaklandIL /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
